import './gallery';
import './photos_favourites';
import './contentSlider';
